import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconEnvelopSharpFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 25 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.011 5h18v14h-18V5Zm15.754 6.185.8-.6-1.2-1.6-.8.6-5.554 4.165-5.553-4.165-.8-.6-1.2 1.6.8.6L11.41 15.8l.6.45.6-.45 6.154-4.615Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconEnvelopSharpFill);
export default Memo;
